import {cerrarSesion} from '../utilities/Seguridad'
import axios from 'axios'
import moment from 'moment';

const qs = require('qs');

export async function getListaColegio(token) {
  
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_URL}/colegio/listar`,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
}


export async function deleteColegio(idColegio, token) {

  let config = {
    method: 'delete',
    url: `${process.env.REACT_APP_URL}/colegio/eliminar/${idColegio}`,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
}

export async function registroColegio(colegio, token) {

  let data = qs.stringify({
    'rbd': colegio.rbd,
    'nombre': colegio.nombre,
    'direccion': colegio.direccion,
    'idcomuna': colegio.comuna.idcomuna,
    'telefono': colegio.telefono,
    'celular': colegio.celular,
    'email': colegio.email,
    'fecha_contrato': moment(colegio.fecha_contrato).format("YYYY-MM-DD"),
    'fecha_caducidad': moment(colegio.fecha_caducidad).format("YYYY-MM-DD"),
    'run_director': colegio.run_director,
    'nombre_director': colegio.nombre_director,
    'ape_paterno_director': colegio.ape_paterno_director,
    'ape_materno_director': colegio.ape_materno_director,
    'fijo_director': colegio.fijo_director,
    'celular_director': colegio.celular_director,
    'email_director': colegio.email_director,
    'idtipo': colegio.dependencia.id
  });

  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_URL}/colegio/crear`,
    headers: {
      'Authorization': `Bearer ${token}`
    },
    data: data
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
}


export async function updateColegio(colegio, token) {
 
  let data = qs.stringify({
    'rbd': colegio.rbd,
    'nombre': colegio.nombre,
    'direccion': colegio.direccion,
    'idcomuna': colegio.comuna.idcomuna,
    'telefono': colegio.telefono,
    'celular': colegio.celular,
    'email': colegio.email,
    'fecha_contrato':  moment(colegio.fecha_contrato).format("YYYY-MM-DD"),
    'fecha_caducidad':  moment(colegio.fecha_caducidad).format("YYYY-MM-DD"),
    'run_director': colegio.run_director,
    'nombre_director': colegio.nombre_director,
    'ape_paterno_director': colegio.ape_paterno_director,
    'ape_materno_director': colegio.ape_materno_director,
    'fijo_director': colegio.fijo_director,
    'celular_director': colegio.celular_director,
    'email_director': colegio.email_director,
    'idtipo': colegio.dependencia.id
  });

  let config = {
    method: 'put',
    url: `${process.env.REACT_APP_URL}/colegio/editar/${colegio.id}`,
    headers: {
      'Authorization': `Bearer ${token}`
    },
    data: data
  };

  const response = await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
  return response;
} 